import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = ({ compact = false }) => {
  const { theme, themeId, setTheme, themes } = useTheme();
  const [open, setOpen] = useState(false);

  if (compact) {
    return (
      <div style={{ position: 'relative' }}>
        <button onClick={() => setOpen(!open)} style={{
          width: 36, height: 36, borderRadius: 10,
          background: theme.bgCard, border: `1px solid ${theme.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', fontSize: 16, transition: 'all 0.2s',
          boxShadow: open ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
        }}>{theme.icon}</button>

        {open && (
          <>
            <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 98 }} />
            <div style={{
              position: 'absolute', top: '100%', right: 0, marginTop: 8,
              padding: 8, borderRadius: 16, minWidth: 200,
              background: theme.bgCard, border: `1px solid ${theme.border}`,
              boxShadow: '0 12px 36px rgba(0,0,0,0.1)', zIndex: 99,
            }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: theme.textDim, padding: '4px 10px 8px', letterSpacing: 1, textTransform: 'uppercase' }}>THEME</div>
              {Object.values(themes).map(t => (
                <button key={t.id} onClick={() => { setTheme(t.id); setOpen(false); }} style={{
                  display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                  padding: '9px 10px', borderRadius: 10,
                  background: themeId === t.id ? theme.accentGreenLight : 'transparent',
                  border: 'none', cursor: 'pointer', textAlign: 'left',
                  transition: 'all 0.15s',
                }}>
                  <span style={{ fontSize: 16 }}>{t.icon}</span>
                  <span style={{
                    flex: 1, fontSize: 13, fontWeight: themeId === t.id ? 700 : 400,
                    color: themeId === t.id ? theme.accentGreen : theme.textSecondary,
                  }}>{t.label}</span>
                  {/* Color swatches */}
                  <div style={{ display: 'flex', gap: 2 }}>
                    {[t.bgPrimary, t.accentGreen, t.accentGold, t.accentRose].map((c, i) => (
                      <div key={i} style={{
                        width: 12, height: 12, borderRadius: 4,
                        background: c, border: `1px solid ${t.border}`,
                      }} />
                    ))}
                  </div>
                  {themeId === t.id && <span style={{ fontSize: 12, color: theme.accentGreen }}>✓</span>}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // Default - compact dropdown for sidebar
  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)} style={{
        display: 'flex', alignItems: 'center', gap: 8, width: '100%',
        padding: '8px 10px', borderRadius: 10,
        background: open ? 'var(--accent-green-light)' : 'transparent',
        border: '1px solid var(--border)', cursor: 'pointer',
      }}>
        <span style={{ fontSize: 14 }}>{theme.icon}</span>
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', flex: 1, textAlign: 'left' }}>{theme.label}</span>
        <span style={{ fontSize: 10, color: 'var(--text-dim)' }}>{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 98 }} />
          <div style={{
            position: 'absolute', bottom: '100%', left: 0, right: 0, marginBottom: 4,
            padding: 6, borderRadius: 12, background: 'var(--bg-card)', border: '1px solid var(--border)',
            boxShadow: 'var(--shadow-lg)', zIndex: 99,
          }}>
            {Object.values(themes).map(t => (
              <button key={t.id} onClick={() => { setTheme(t.id); setOpen(false); }} style={{
                display: 'flex', alignItems: 'center', gap: 8, width: '100%',
                padding: '7px 10px', borderRadius: 8, border: 'none', cursor: 'pointer',
                background: themeId === t.id ? 'var(--accent-green-light)' : 'transparent',
              }}>
                <span style={{ fontSize: 14 }}>{t.icon}</span>
                <span style={{ fontSize: 12, fontWeight: themeId === t.id ? 700 : 400, color: themeId === t.id ? 'var(--accent-green)' : 'var(--text-muted)' }}>{t.label}</span>
                {themeId === t.id && <span style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--accent-green)' }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ThemeToggle;
